import { render, staticRenderFns } from "./DragableModal.vue?vue&type=template&id=1a6abfc4&scoped=true&"
import script from "./DragableModal.vue?vue&type=script&lang=js&"
export * from "./DragableModal.vue?vue&type=script&lang=js&"
import style0 from "./DragableModal.vue?vue&type=style&index=0&id=1a6abfc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6abfc4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VIcon})
